fetch(window.Shopify.routes.root + "pages/cart-drawer/ajax-cart")
  .then((response) => {
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    return response.text();
  })
  .then((data) => {
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(data, "text/html");
    const cartContent = htmlDoc.querySelector(".section-custom-cart-drawer");
    if (cartContent) {
      document.body.appendChild(cartContent);
    } else {
      console.error("Unable to find cart content section in the fetched data");
    }
  })
  .catch((error) => {
    console.error("There was a problem with your fetch operation:", error);
  });

document.addEventListener("DOMContentLoaded", function () {
  var ajaxCartTrigger = document.querySelector(".ajax-cart-trigger");
  if (!ajaxCartTrigger) return;
  ajaxCartTrigger.addEventListener("click", function () {
    updateAjaxCart();
  });
});

document.addEventListener(
  "DOMContentLoaded",
  removeRelatedProductsWithoutParent
);

document.addEventListener("cartUpdated", function (event) {
  removeRelatedProductsWithoutParent(event.detail);
});

document.addEventListener("click", function (event) {
  var cartDialog = document.getElementById("cart-drawer-custom");
  var cartHeader = cartDialog.querySelector(".cart-header");
  var cartContent = cartDialog.querySelector(".cart-content");
  var cartRedirectButtonAjax = document.getElementById(
    "visualitzar-cistella-ajax"
  );
  var checkoutRedirectButtonAjax = document.getElementById(
    "ajax-button-checkout"
  );
  var productsArray = getProductsCart();
  var varVoid;
  var fcbdlCartProducts = productsArray.join(", ");
  var combinedString = document
    .getElementById("combinedStringData")
    .getAttribute("data-combined-string");
  if (cartDialog.hasAttribute("open")) {
    if (
      !cartContent.contains(event.target) &&
      !cartHeader.contains(event.target)
    ) {
      cartDialog.close();
    } else if (event.target.id === "close-cart") {
      cartDialog.close();
      trackEvents("tancar-cistella-ajax", varVoid);
    } else if (event.target.id === "product-afegir-cistella-ajax") {
      analiticaSku = event.target.getAttribute("analitica-sku");
      trackEvents("afegir-cistella-ajax", analiticaSku);
    } else if (event.target.id === "product-eliminar-cistella-ajax") {
      analiticaSku = event.target.getAttribute("analitica-sku");
      trackEvents("eliminar-cistella-ajax", analiticaSku);
    } else if (event.target.classList.contains("remove-ajax")) {
      analiticaSku = event.target.getAttribute("analitica-sku");
      trackEvents("eliminar-cistella-ajax", analiticaSku);
    } else if (
      cartRedirectButtonAjax &&
      cartRedirectButtonAjax.contains(event.target)
    ) {
      trackEvents("visualitzar-cistella-ajax", varVoid);
    } else if (checkoutRedirectButtonAjax.contains(event.target)) {
      trackEvents("finalitzar-compra-ajax", combinedString);
    }
  }
});

function debounce(func, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}

function updateAjaxCart() {
  updateCartDrawer().then(() => {
    var cartDialog = document.getElementById("cart-drawer-custom");
    var closeCartButton = document.getElementById("close-cart");
    cartDialog.showModal();
    window.kitDataLayer.trackCartView();
    fetchCartData();
  });
}

async function removeRelatedProductsWithoutParent(cartEvent) {
  try {
    let cart = cartEvent;
    if (!cartEvent) {
      const response = await fetch("/cart.js");
      cart = await response.json();
    }
    const mainProductIds = cart?.items?.map(
      (item) => item.properties._product_id
    );

    for (const item of cart.items) {
      const relatedProductId =
        item.properties && item.properties._related_product_id;
      // Si existe un producto relacionado sin su padre, lo eliminamos
      if (relatedProductId && !mainProductIds.includes(relatedProductId)) {
        await fetch(`/cart/change.js?quantity=0&id=${item.key}`, {
          method: "POST",
        });
      }
    }
    // Llamamos a updateCartDrawer para asegurarnos de que el carrito se actualiza
    updateCartDrawer();
  } catch (error) {
    console.error("Error removing related products without parent:", error);
  }
}

function updateProductsCart(cartData, updates, cartDrawer) {
  if (cartData && updates) {
    const itemRemoved = Object.values(updates).some((value) => value === 0);
    if (!itemRemoved) {
      Object.entries(updates).forEach(([key, value]) => {
        const item = cartDrawer.querySelector(
          `.fcb-quantity__input_ajax[data-key="${key}"]`
        );
        if (item !== null) {
          item.value = value;
          if (value === 1) {
            item.previousElementSibling.disabled = true;
          } else {
            item.previousElementSibling.disabled = false;
          }
        }
      });
      return true;
    }
    return false;
  }
}

function parsePrices(priceText, addedValue) {
  priceText = priceText.trim();

  let symbol = priceText.match(/^[^\d\s]+/)?.[0] || "";
  let currency = priceText.match(/[A-Za-z]+$/)?.[0] || "";

  let numericValue = parseFloat(
    priceText
      .replace(symbol, "")
      .replace(currency, "")
      .replace(".", "")
      .replace(",", ".")
  );

  let newValue = addedValue / 100;

  let formattedValue = new Intl.NumberFormat("es-ES", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(newValue);
  let newPriceText = `${symbol}${formattedValue} ${currency}`;

  return newPriceText;
}

function countItems(itemsCart) {
  return itemsCart.reduce((acc, item) => {
    if (!item.properties.hasOwnProperty("_related_product_id")) {
      return acc + item.quantity;
    }
    return acc;
  }, 0);
}

function parseItems(itemQuantity, number) {
  itemQuantity = itemQuantity.trim();
  let updatedItemText = itemQuantity.replace(/\d+/, number);
  return updatedItemText;
}

function updatePriceSection(
  cartData,
  subPriceElement,
  totalPriceElement,
  totalItemsElement,
  discountElement
) {
  if (cartData && subPriceElement) {
    const subPrice = cartData.total_price;
    subPriceElement.textContent = parsePrices(
      subPriceElement.textContent,
      subPrice
    );
    if (
      totalPriceElement?.textContent &&
      totalItemsElement?.textContent &&
      discountElement?.textContent
    ) {
      const totalPrice = cartData.original_total_price;
      const itemsCart = cartData.items;
      const itemsCount = countItems(itemsCart);
      const discount = cartData.total_discount;

      totalPriceElement.textContent = parsePrices(
        totalPriceElement.textContent,
        totalPrice
      );
      discountElement.textContent = parsePrices(
        discountElement.textContent,
        discount
      );
      totalItemsElement.textContent = parseItems(
        totalItemsElement.textContent,
        itemsCount
      );
    }
    return true;
  }
}

function updateBagCount(itemBagElement, itemBagIcon, cartData) {
  const itemsCount = countItems(cartData?.items);
  if (itemBagElement && itemBagIcon) {
    itemBagElement.textContent = itemsCount;
    itemBagIcon.setAttribute("data-items", itemsCount);
    return true;
  }
}

async function updateCartDrawer(cartData, updates) {
  try {
    const cartDrawer = document.getElementById("cart-drawer-custom");
    if (!cartDrawer) return;

    const elementsToUpdate = {
      ".cart__items-ajax": cartDrawer.querySelector(".cart__items-ajax"),
      "slider-component": cartDrawer.querySelector("slider-component"),
      ".cart-header h3 span": cartDrawer.querySelector(".cart-header h3 span"),
      ".fcb-progress-bar__bar-wrapper": cartDrawer.querySelector(
        ".fcb-progress-bar__bar-wrapper"
      ),
      "#cart-drawer-order-summary": cartDrawer.querySelector(
        "#cart-drawer-order-summary"
      ),
      ".ajax-cart__subtotal-price": cartDrawer.querySelector(
        ".ajax-cart__subtotal-price"
      ),
      "#cart_discount_amount": cartDrawer.querySelector(
        "#cart_discount_amount"
      ),
      "#ajax-button-checkout": cartDrawer.querySelector(
        "#ajax-button-checkout"
      ),
      "#cart_original_total_items": cartDrawer.querySelector(
        "#cart_original_total_items"
      ),
      "#cart_original_total_price": cartDrawer.querySelector(
        "#cart_original_total_price"
      ),
    };

    if (cartData) {
      const productUpdated = updateProductsCart(cartData, updates, cartDrawer);
      const pricesUpdated = updatePriceSection(
        cartData,
        elementsToUpdate[".ajax-cart__subtotal-price"],
        elementsToUpdate["#cart_original_total_price"],
        elementsToUpdate["#cart_original_total_items"],
        elementsToUpdate["#cart_discount_amount"]
      );
      const bagCountUpdated = updateBagCount(
        cartDrawer.querySelector(".item-count-ajax"),
        document.querySelector("#ajaxCartTrigger"),
        cartData
      );
      if (this.open) {
        window.checkCartUpdate(cartData);
      }
      if (productUpdated) return;
    }

    const cartContent = await getAjaxCart();
    if (!cartContent) return;

    const html = document.createElement("div");
    html.innerHTML = cartContent;
    const newBox = html.querySelector("#cart-drawer-custom");
    if (!newBox) return;

    Object.entries(elementsToUpdate).forEach(([selector, element]) => {
      const newContent = newBox.querySelector(selector)?.innerHTML;
      if (element && newContent) element.innerHTML = newContent;
    });

    const cartSlider = elementsToUpdate["slider-component"];
    const hasItems =
      newBox.querySelector(".cart__items-ajax .js-contents-items")?.childNodes
        .length > 0;
    cartSlider?.classList.toggle("hidden", !hasItems);

    const orderSummary = elementsToUpdate["#cart-drawer-order-summary"];
    const cartDiscount =
      elementsToUpdate["#cart_discount_amount"].textContent.trim();
    const cartDiscountParsed = cartDiscount.replace(/[^\d,]/g, "");
    const discountValue = parseFloat(cartDiscountParsed.replace(",", "."));
    if (discountValue > 0) {
      orderSummary.classList.remove("hidden");
    } else {
      orderSummary.classList.add("hidden");
    }

    const cartCount = html
      .querySelector(".cart-content")
      ?.getAttribute("data-item-count");
    document
      .querySelector(".fcb-header__icon.fcb-counter.ajax-cart-trigger")
      ?.setAttribute("data-items", cartCount || "");

    const combinedString = html
      .querySelector("#combinedStringData")
      ?.getAttribute("data-combined-string");
    document
      .getElementById("combinedStringData")
      ?.setAttribute("data-combined-string", combinedString || "");
  } catch (error) {
    console.error("Error fetching or updating cart drawer:", error);
  }
}

async function getAjaxCart() {
  try {
    const response = await fetch(
      window.Shopify.routes.root + "pages/cart-drawer/ajax-cart"
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = await response.text();
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(data, "text/html");
    const cartContent = htmlDoc.querySelector(".section-custom-cart-drawer");
    return cartContent ? cartContent.innerHTML : null;
  } catch (error) {
    console.error("Error fetching cart content:", error);
    return null;
  }
}

document.addEventListener("addToCartSuccess", function (event) {
  updateAjaxCart();
});

function fireTrackEvent(event) {
  const closestLi = event.target.closest("li");
  const dataFCBDL = closestLi ? closestLi.getAttribute("data-fcbdl") : "";
  trackEvents("embolicar-compra-ajax", dataFCBDL);
}

function handleOneMore(event) {
  const clickedElement = event.target.closest(".one-more__submit");
  const defaultCart = event.target.closest("cart-items");
  if (!clickedElement || defaultCart) return;

  event.preventDefault();
  const formElement = clickedElement.closest("form");
  if (formElement) {
    submitFormOneMore(formElement, event);
  } else {
    console.error("Form element not found.");
  }
}

// Attach the event listener to a parent element that exists when the page loads
document.addEventListener("click", handleOneMore);

function submitFormOneMore(formElement, event) {
  const formData = new FormData(formElement);
  fetch(formElement.action, {
    method: "POST",
    body: formData,
  })
    .then((response) => {
      if (response.ok) {
        const product = window.kitDataLayer.addOneMore(formElement); // <--- this line
        if (product) {
          window.kitDataLayer.dispatchEvent({
            category: "ecommerce",
            action: "cart_add",
            placement: "cart_add_cart_ajax",
            context: {
              product: [product],
              event: "cart_add",
              list_name: "one-more",
              list_position: 1,
            },
          });
        }
        updateCartDrawer();
      }
    })
    .catch((error) => {
      console.error("Error submitting form:", error);
    });
}

document.addEventListener("click", checkElementExistence);

function checkElementExistence(event) {
  let clickedElement = event.target;
  if (clickedElement.classList.contains("remove-ajax")) {
    event.preventDefault();
    if (clickedElement.tagName === "svg" || clickedElement.tagName === "path") {
      const closestButton = clickedElement.closest("cart-remove-button-ajax");
      clickedElement = closestButton;
    }
    const itemId = clickedElement.getAttribute("data-id");
    const productId = clickedElement.getAttribute("data-productid-ajax");

    const dataKey = clickedElement.getAttribute("data-key");
    const allRelatedProducts = document.querySelectorAll(
      ".fcb-cart-related-item, fcb-cart-related-item"
    );

    if (allRelatedProducts.length) {
      const relatedProducts = [];
      allRelatedProducts.forEach((relatedProduct) => {
        if (
          relatedProduct.getAttribute("data-relatedproductid") === productId
        ) {
          relatedProducts.push(relatedProduct);
        }
      });
      debouncedUpdateCart(dataKey, 0, relatedProducts);
      // updateProductQuantity(dataKey, 0, relatedProducts)
      return;
    }

    if (dataKey) {
      // updateProductQuantity(dataKey, 0)
      debouncedUpdateCart(dataKey, 0);
    } else {
      // updateProductQuantity(parseInt(itemId), 0)
      debouncedUpdateCart(parseInt(itemId), 0);
    }

    return;
  }

  if (clickedElement.classList.contains("fcb-quantity__button_ajax")) {
    const quantityInput = clickedElement.closest(".fcb-quantity-ajax");
    const input = quantityInput.querySelector(".fcb-quantity__input_ajax");
    const productId = input.getAttribute("data-productid");
    const itemId = quantityInput.getAttribute("item-id");
    const dataKey = input.getAttribute("data-key");
    const newValue = parseInt(input.value);

    if (dataKey) {
      const allRelatedProducts = document.querySelectorAll(
        ".fcb-cart-related-item, fcb-cart-related-item"
      );
      const relatedProducts = [];
      allRelatedProducts.forEach((relatedProduct) => {
        if (
          relatedProduct.getAttribute("data-relatedproductid") === productId
        ) {
          relatedProducts.push(relatedProduct);
        }
      });
      // updateProductQuantity(dataKey, newValue, relatedProducts)
      // .catch(error => {
      //   console.error('Error updating product quantity:', error)
      // })
      debouncedUpdateCart(dataKey, newValue, relatedProducts);
    } else {
      debouncedUpdateCart(parseInt(itemId), newValue);
      // updateProductQuantity(parseInt(itemId), newValue)
    }
    return;
  }
}

const debouncedUpdateCart = debounce(updateProductQuantity, 300);

function updateProductQuantity(id, newValue, relatedProducts) {
  const updates = { [id]: newValue };

  if (relatedProducts?.length) {
    relatedProducts.forEach((relatedProduct) => {
      updates[relatedProduct.getAttribute("data-key")] = newValue;
    });
  }

  return new Promise((resolve, reject) => {
    const fetchUrl = "https://store.fcbarcelona.com/cart/update.js";

    fetch(fetchUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    })
      .then((response) => response.json())
      .then((data) => {
        updateCartDrawer(data, updates);
        resolve();
      })
      .catch((error) => {
        console.error("Error:", error);
        reject(error);
      });
  });
}

document.addEventListener("cartUpdated", function (event) {
  updateAjaxCart();
});

async function removeRelatedProductsFromCart() {
  try {
    const response = await fetch("/cart.js");
    const cart = await response.json();
    const mainProductIds = cart.items.map(
      (item) => item.properties._product_id
    );
    let maliciousCasesFound = false;

    for (const item of cart.items) {
      const relatedProductId =
        item.properties && item.properties._related_product_id;

      if (relatedProductId && !mainProductIds.includes(relatedProductId)) {
        fetch(`/cart/change.js?quantity=0&id=${item.key}`, { method: "POST" });
        maliciousCasesFound = true;
      }
    }

    if (maliciousCasesFound) {
      await removeRelatedProductsFromCart();
    } else {
      updateCartDrawer();
    }
  } catch (error) {
    console.error("Error removing related products from the cart:", error);
  }
}

removeRelatedProductsFromCart();

if (document.getElementById("cart-drawer-custom")) {
  document
    .getElementById("cart-drawer-custom")
    .addEventListener("toggle", function (event) {
      if (this.open) {
        // Cuando el drawer se abre, ejecuta las funciones de progress-bar.js
        fetchCartData();
      }
    });
}
